import { useCallback } from 'react'
import { setAuction } from '../../service/nft'
// hooks
import { useActiveWeb3React } from '../'

const useAuction = (tokenId: string, nftType?: string) => {
  const {account, library, chainId} = useActiveWeb3React()
  
  const handleAuction = useCallback(
    async (price: string) => {
      return new Promise(resolve => {
        if (!library) return
        let time = Math.round(new Date().getTime()/1000).toString()
        library
          .send('eth_sign', [account, (tokenId + '-' + time)])
          .then(signature => {
            let param = {
              timestamp: time,
              nftId: tokenId,
              auctionPrice: price,
              signature: signature,
              nftType: nftType
            }
            setAuction(chainId as number, param, (err: any, d: any) => {
              if (err || d.code !== 0) resolve('')
              if (err) return
              if (d.code !== 0) return
              resolve(d)
            })
          })
          .catch(error => {
            console.log('err', error)
            resolve('')
        })
      })
    },
    [tokenId, account, library, chainId, nftType],
  )

  return { onAuction: handleAuction }
}

export default useAuction
